const MOBILE_MENU_MQ = window.matchMedia("(max-width: 1275px)")

export default function MenuFunc() {
	const closeButton = document.querySelector(".close_menu")
	const menu_left = document.querySelector("#meuHover")

	document.querySelectorAll(".menu-togle, .menu-togle_black").forEach((toggle) => {
		toggle.addEventListener("click", () => {
			menu_left?.classList.add("slide-in-menu")
		})
	})

	closeButton?.addEventListener("click", () => {
		menu_left?.classList.remove("slide-in-menu")
		closeAllMenuAccordions()
	})

	initMobileMenuAccordion()
	initTratamentosHoverModal()
}

function initTratamentosHoverModal() {
	const triggers = document.querySelectorAll(".menu-tratamentos-trigger")
	const popup = document.getElementById("popup-tratamentos")
	if (!triggers.length || !popup) return

	const desktopMq = window.matchMedia("(min-width: 1276px)")
	let closeTimeout = null

	const clearCloseTimeout = () => {
		if (closeTimeout) {
			clearTimeout(closeTimeout)
			closeTimeout = null
		}
	}

	const scheduleClose = () => {
		clearCloseTimeout()
		closeTimeout = setTimeout(() => {
			window.closePopupTratamentos?.()
		}, 200)
	}

	const bindHoverZone = (element) => {
		element.addEventListener("mouseenter", () => {
			if (!desktopMq.matches) return
			clearCloseTimeout()
			window.openPopupTratamentos?.()
		})

		element.addEventListener("mouseleave", () => {
			if (!desktopMq.matches) return
			scheduleClose()
		})
	}

	triggers.forEach(bindHoverZone)
	bindHoverZone(popup)
}

function closeAllMenuAccordions() {
	document.querySelectorAll("#meuHover .menu-accordion-open").forEach((accordion) => {
		accordion.classList.remove("menu-accordion-open")
		accordion.querySelector(".menu-accordion-trigger[data-accordion]")?.setAttribute("aria-expanded", "false")
	})
}

function initMobileMenuAccordion() {
	const menuPanel = document.querySelector("#meuHover")
	if (!menuPanel) return

	menuPanel.addEventListener("click", (event) => {
		if (!MOBILE_MENU_MQ.matches) return

		const trigger = event.target.closest(".menu-accordion-trigger[data-accordion]")
		if (!trigger || !menuPanel.contains(trigger)) return

		event.preventDefault()
		event.stopPropagation()

		const accordion = trigger.closest(".menu-accordion")
		if (!accordion) return

		const isOpen = accordion.classList.contains("menu-accordion-open")
		closeAllMenuAccordions()

		if (!isOpen) {
			accordion.classList.add("menu-accordion-open")
			trigger.setAttribute("aria-expanded", "true")
		}
	})

	menuPanel.addEventListener("click", (event) => {
		if (!MOBILE_MENU_MQ.matches) return

		const link = event.target.closest("a.menu-submenu-link")
		if (!link || !menuPanel.contains(link)) return

		menuPanel.classList.remove("slide-in-menu")
		closeAllMenuAccordions()
	})
}
